<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="flex flex-wrap items-center mb-base">
        <vs-avatar
          :src="formData.file !== null ? `${url.baseFl}/${formData.file}` : emptyImage"
          size="70px"
          class="mr-4 mb-4"
        />
        <div>
          <input
            type="file"
            class="hidden"
            ref="updateImgInput"
            @change="updateCurrImg"
            accept="image/*"
          />
          <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.updateImgInput.click()"
            >Upload photo</vs-button
          >
          <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
        </div>
      </div>

      <!-- Img Row -->
      <!-- <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />
      <div>
        <vs-button class="mr-4 sm:mb-0 mb-2">Upload photo</vs-button>
        <vs-button type="border" color="danger">Remove</vs-button>
        <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p>
      </div>
    </div> -->

      <!-- Info -->
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Lengkap</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Nama User"
        />
        <span class="text-danger text-sm">{{ errors.first("name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Status</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="[
            { id: 1, text: 'Verify' },
            { id: 0, text: 'Un-Verify' },
          ]"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="status"
          label="text"
          v-model="formData.status"
          placeholder="Pilih Status Akun"
        />
        <span class="text-danger text-sm">{{ errors.first("status") }}</span>
      </div>
      <div class="mb-6" v-if="passData === null">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Jenis</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="[
            { id: 1, text: 'User' },
            { id: 2, text: 'Admin' },
          ]"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="jenis"
          label="text"
          v-model="jenis"
          placeholder="Pilih Jenis Akses"
        />
        <span class="text-danger text-sm">{{ errors.first("jenis") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Level</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="levels"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          :disabled="levels.length === 0"
          name="level"
          label="name"
          v-model="formData.level_id"
          placeholder="Pilih Level"
        />
        <span class="text-danger text-sm">{{ errors.first("level") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Email</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required|email|min:4'"
          data-vv-validate-on="blur"
          name="email"
          class="w-full sidebar-input"
          v-model="formData.email"
          placeholder="Isi dengan Email Kamu"
        />
        <span class="text-danger text-sm">{{ errors.first("email") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>No. Telepon</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <!-- <VuePhoneNumberInput
          default-country-code="ID"
          no-country-selector
          @update="formData.no_telp = $event.e164"
          name="phone"
          :error="formData.no_telp === '' || formData.no_telp === null"
          v-model="formData.no_telp"
          class="w-full mb-3"
        /> -->
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="phone"
          @keypress="onlyNumber"
          class="w-full sidebar-input"
          v-model="formData.no_telp"
          placeholder="Isi dengan No.Telepon Kamu"
        />
        <span class="text-danger text-sm">{{ errors.first("phone") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Password</strong></h6>
          <span v-if="passData === null" class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="password"
          type="password"
          class="w-full sidebar-input"
          v-model="password"
          placeholder="Isi Password Baru"
        />
        <span class="text-danger text-sm">{{ errors.first("password") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addWithOption"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    VuePhoneNumberInput,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      formData: {
        level_id: null,
        status: null,
        name: "",
        email: "",
        no_telp: "",
        file: emptyImage,
      },
      levels: [],
      jenis: "",
      password: "",
      user: null,
      phoneInput: null,
      binaryFile: "",
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit User" : "Tambah User";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      if (this.passData === null) {
        return (
          !this.errors.any() &&
          this.formData.name !== "" &&
          this.formData.email !== "" &&
          this.formData.no_telp !== "" &&
          this.formData.level_id !== null &&
          this.formData.email !== "" &&
          this.formData.status !== null &&
          this.formData.email !== "" &&
          this.formData.file !== "" &&
          this.password !== "" &&
          this.jenis !== ""
        );
      } else {
        return (
          !this.errors.any() &&
          this.formData.name !== "" &&
          this.formData.email !== "" &&
          this.formData.no_telp !== "" &&
          this.formData.level_id !== null &&
          this.formData.email !== "" &&
          this.formData.status !== null &&
          this.formData.email !== "" &&
          this.formData.file !== ""
        );
      }
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.$store.state.level.kategoriList.length !== 0) {
        console.log(this.$store.state.level.kategoriList);
        this.levels = this.$store.state.level.kategoriList;
      } else {
        this.getLevels();
      }

      if (this.passData !== null) {
        this.formData.status = this.passData.status;
        this.formData.name = this.passData.name;
        this.formData.email = this.passData.email;
        this.formData.no_telp = this.passData.no_telp;
        this.formData.file = this.getPathFoto(this.passData);
        this.formData.level_id = this.passData.level.id;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.status = null;
      this.formData.name = "";
      this.formData.email = "";
      this.formData.no_telp = "";
      this.formData.file = this.emptyImage;
      this.formData.level_id = null;
      this.password = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      console.log(this.passData);
      if (this.binaryFile === "") {
        this.addData();
      } else {
        this.addWithFile();
      }
    },
    addWithFile() {
      this.$store
        .dispatch("file/addFile", this.binaryFile)
        .then((v) => {
          this.formData.file = v.link;
          this.addData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.binaryFile = "";
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getLevels() {
      this.$store
        .dispatch("level/getLevel", {})
        .then((v) => {
          console.log(v);
          this.levels = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      let id = {};
      let add = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === emptyImage) {
        this.formData.file = null;
      }

      if (this.passData === null) {
        add = {
          jenis: this.jenis,
          password: this.password,
        };
      } else {
        let pass = {};
        let jenis = {};
        if (this.password !== "" || this.password !== null) {
          pass = {
            password: this.password,
          };
        }

        if (this.jenis !== null) {
          jenis = {
            jenis: this.jenis,
          };
        }

        add = {
          ...pass,
          ...jenis,
        };
      }

      this.$store
        .dispatch("users/cudUsers", [{ ...this.formData, ...id, ...add }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title: this.passData !== null ? "Edit User Sukses!" : "Tambah User Sukses!",
            text:
              this.passData !== null
                ? `User ${v.name} Berhasil diedit`
                : `User ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();

          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
};
</script>
